import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

const TABS = [
    { key: 'all', label: 'All' },
    { key: 'chats', label: 'Chats' },
    { key: 'tickets', label: 'Tickets' },
    { key: 'knowledgeBase', label: 'Knowledge Base' },
]

const SearchTabs = ({ activeTab, onTabChange, counts }) => {
    return (
        <Box sx={{ display: 'flex', gap: '24px', marginBottom: '24px' }}>
            {TABS.map((tab) => {
                const count = counts[tab.key];
                const isActive = activeTab === tab.key;
                return (
                    <Typography
                        key={tab.key}
                        onClick={() => onTabChange(tab.key)}
                        sx={{
                            color: isActive ? '#061522' : '#405261',
                            cursor: 'pointer',
                            fontFamily: 'Inter',
                            fontSize: '14px',
                            fontStyle: 'normal',
                            fontWeight: isActive ? 500 : 400,
                            lineHeight: '18px',
                            paddingBottom: '8px',
                            borderBottom: isActive ? '1px solid #148DFD' : '1px solid transparent',
                            userSelect: 'none',
                            transition: 'color 0.15s ease',
                            '&:hover': {
                                color: '#061522',
                            },
                        }}
                    >
                        {tab.label}
                        {count !== undefined && count !== null ? ` (${count})` : ''}
                    </Typography>
                );
            })}
        </Box>
    );
};

export default SearchTabs;
